export default `
  mutation DeleteBCObject($id: ID!) {
    deleteBCObject(id: $id) {
      id
    }
  }
`
